<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="接口名称">
                <el-input v-model="formInline.action" placeholder="接口名称"></el-input>
            </el-form-item>
            <el-form-item label="起始日期">
                <el-date-picker
                        v-model="formInline.fromDate"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="findList">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="AccessLogsList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="LOG_TIME" label="时间"></el-table-column>
            <el-table-column prop="AVG_TIME" label="平均耗时(毫秒)"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {getActionLogPerSecond} from '@/api/api';
    export default {
        data() {
            return {
                AccessLogsList: [],
                loading: true,
                formInline: {
                    action: '',
                    fromDate: '',
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '三天前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.findList();
        },
        methods: {
            findList(){
                if(this.formInline.action == null){
                    this.$message({
                        message: '请输入接口',
                        type: 'error'
                    });
                    return;
                }
                getActionLogPerSecond(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.length;
                        this.AccessLogsList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findList();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/monitor/AccessLogsOfAction.vue